import React from 'react'

import type { EditableTrack, TrackId } from 'types/track'

import { RightsManagement } from './rights-management'

interface WritersManagementProps {
  editedTrack: EditableTrack & {
    trackIds?: TrackId[]
  }
  saving: boolean
  hasUnsavedChanges?: boolean
  updateEditedTrack: (track: any) => void
  saveTrackMetadata: (opts?: any) => void
  sendMixpanelEvent: (event: string) => void
  attach_writers_to_metadata: boolean
  /* New Rights API model feature flag - To be removed as part of SLAM-1413 clean up */
  rightsNewModelEnabled?: boolean
  /** Hide the footer's "Copy track info" when the surrounding chrome
   *  already offers it (e.g. the track edit modal header). */
  hideCopyMetadata?: boolean
  /** Dismisses the surrounding modal. Passing it gives the footer a Cancel
   *  button beside Save. */
  onClose?: () => void
}

/**
 * WritersManagement - A table-based UI for managing writer rights and splits
 *
 * This component replaces the old TrackWriters component when SPLITS_V2 flag is active.
 * It provides a cleaner table interface for managing writer splits with inline editing.
 * Supports both single track editing and bulk editing (when multiple tracks are selected).
 *
 * When rightsNewModelEnabled is true, renders PublishingRightsManagement instead,
 * which provides Publishing/Recording tabs and uses the new rights splits API.
 * Feature flags to be cleaned up as a part of SLAM-1413 after release
 */
export function WritersManagement({
  editedTrack,
  saving,
  hasUnsavedChanges,
  updateEditedTrack,
  saveTrackMetadata,
  sendMixpanelEvent,
  attach_writers_to_metadata,
  hideCopyMetadata,
  onClose,
}: WritersManagementProps) {
  return (
    <RightsManagement
      editedTrack={editedTrack}
      saving={saving}
      hasUnsavedChanges={hasUnsavedChanges}
      updateEditedTrack={updateEditedTrack}
      saveTrackMetadata={saveTrackMetadata}
      sendMixpanelEvent={sendMixpanelEvent}
      attach_writers_to_metadata={attach_writers_to_metadata}
      hideCopyMetadata={hideCopyMetadata}
      onClose={onClose}
    />
  )
}

export default WritersManagement
